// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable no-else-return */
import {
  LOGINPAGE_REDUCER_KEY,
  SESSIONCONFIG_REDUCER_KEY,
} from '@tcp/core/src/constants/reducer.constants';
import { parseBoolean } from '@tcp/core/src/utils/badge.util';
import { createSelector } from 'reselect';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import {
  getIsLogonRecaptchaEnabled,
  getIsEmailRecaptchaEnabled,
  getEmailRecaptchaThresold,
} from '../../../../../reduxStore/selectors/session.selectors';
import { GlobalLoginLabels } from '../../../../../utils/labels/globalLogin.labels';

export const getLoginReducer = (state) => {
  return state[LOGINPAGE_REDUCER_KEY];
};

export const getLoginState = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('error');
};

export const getExistingUserResponse = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('existingUserResponse');
};

export const loginModalOpenState = (state) => {
  return state.LoginPageReducer && state.LoginPageReducer.get('loginModalMountedState');
};

export const checkoutModalOpenState = (state) => {
  return state.LoginPageReducer && state.LoginPageReducer.get('checkoutModalMountedState');
};

export const getAccountCardVisibility = (state) => {
  return state.LoginPageReducer && state.LoginPageReducer.get('isAccountCardVisible');
};

export const getCountryCode = (state) => {
  return state.LoginPageReducer && state.LoginPageReducer.get('phoneCountryCode');
};

export const checkoutModalComponentType = (state) => {
  return state.LoginPageReducer && state.LoginPageReducer.get('componentType');
};

export const getUserLoggedInState = createSelector(
  getLoginState,
  (loginState) => loginState && loginState.get('isLoggedin')
);

export const getPlccLoadingState = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('isPlccLoginLoading');
};

export const getLoadingState = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('isLoading');
};

export const getLoginError = createSelector(
  getLoginState,
  (loginState) => loginState && loginState.get('success') === false
);

export const getShowErrorModal = createSelector(
  getLoginState,
  (loginState) =>
    loginState &&
    loginState.get('networkStatusCode') !== 200 &&
    loginState.get('networkStatusCode') !== undefined
);

export const getGuestFavMessages = () => {
  return {
    dontLoseFav: getLabelFromCopyOrFromTranslation(
      'global.login.lbl_guestFavLogin_dlf',
      GlobalLoginLabels
    ),
    loginOrCreate: getLabelFromCopyOrFromTranslation(
      'global.login.lbl_guestFavLogin_lic',
      GlobalLoginLabels
    ),
    wishlistAddStyle: getLabelFromCopyOrFromTranslation(
      'global.login.lbl_guestFavLogin_wishlist_add_style',
      GlobalLoginLabels
    ),
  };
};

export const getLogonRecaptchaThresold = (state) => {
  return state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.LOGON_RECAPTCHA_THRESHOLD
    ? +state.session.siteDetails.LOGON_RECAPTCHA_THRESHOLD
    : 3;
};

export const shouldShowRecaptcha = createSelector(
  [getLoginState, getIsLogonRecaptchaEnabled, getLogonRecaptchaThresold],
  (ErrorState, logonRecaptchaEnabled, LogonRecaptchaThresold) => {
    return (
      ErrorState &&
      logonRecaptchaEnabled &&
      parseInt(ErrorState.getIn(['errors', '0', 'errorParameters', 'retriesCount']) || 0, 10) >=
        LogonRecaptchaThresold
    );
  }
);

export const shouldShowEmailRecaptcha = createSelector(
  [getLoginReducer, getIsEmailRecaptchaEnabled, getEmailRecaptchaThresold],
  (loginState, emailRecaptchaEnabled, emailRecaptchaThresold) =>
    loginState && emailRecaptchaEnabled
      ? parseInt(loginState.get('emailRetry') || 0, 10) >= emailRecaptchaThresold
      : false
);

export const getIsLoginWithOTPEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.LOGIN_WITH_OTP)
  );
};

export const getLoginWithEmailOTPEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.LOGIN_WITH_EMAIL_OTP)
  );
};

export const getIsShowPhoneLoginOption = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('isShowPhoneLoginOption');
};

export const getMaskedPhoneNumber = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('maskedPhoneNumber');
};

export const getIsShowOTPInputScreen = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('isShowOTPInputScreen');
};

export const getOTPToken = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('otpToken');
};

export const getUserNotExist = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('userNotExist');
};

export const getShowEmailScreen = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('showEmailScreen');
};

export const getLoginSelectedOption = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('loginSelectionOption');
};

export const getIsOtpLimit = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('isOtpLimit');
};

export const getIsLocked = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('isLocked');
};

export const getIsNewLoginScreenApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NEW_LOGIN_SCREEN_APP)
  );
};
